import { css } from "styled-components";
import { riotProductSkin as richTextRiotProductSkin } from "../../../../skins/riot-product";
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${richTextRiotProductSkin(chroma, paletteTokens)}

  & {
    &,
    p,
    li {
      ${chroma.typography.body4};
    }
  }
`;
//# sourceMappingURL=index.js.map